{
  "en": {
    "baseBtn": {
      "labels": {
        "loading": "Please wait..."
      }
    }
  }
}
